<template>
  <div style="padding: 120px 24px 80px 24px; max-width: 800px; margin: 0 auto;">
    <LandingLoader v-if="loading" />
    
    <div v-else class="fetched-content-card">
      <!-- API Rendered HTML Content -->
      <div v-if="fetchedContent" v-html="fetchedContent" class="fetched-content-wrapper"></div>
      
      <!-- Static Fallback Content -->
      <div v-else>
        <h1 style="font-size: 36px; margin-bottom: 20px;">Privacy Policy</h1>
        <p style="color: var(--text-muted); line-height: 1.8;">
          Privacy policies regarding users and rescuers utilizing the SARPA MP mobile application.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import LandingLoader from '../components/LandingLoader.vue';

export default {
  name: 'PrivacyPolicy',
  components: {
    LandingLoader
  },
  data() {
    return {
      loading: true,
      fetchedContent: null
    };
  },
  mounted() {
    axios.get('/content/get/privacy_policy')
      .then(response => {
        if (response.data && response.data.status && response.data.data && response.data.data.content) {
          this.fetchedContent = response.data.data.content.content;
        }
      })
      .catch(error => {
        console.error('Error fetching Privacy Policy content:', error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>
